import { Skeleton, SkeletonTable } from '@zagru/design-system';

/**
 * The shell's silhouette while the session is restored or the workspace opens: navigation rail, top bar and a
 * page body in their final positions, so a reload never flashes an unrelated screen (ADR-0022).
 */
export function ShellSkeleton({ label }: { label: string }) {
  return (
    <div className="zo-shell-skeleton flex h-dvh overflow-hidden bg-surface-0" aria-busy="true" aria-label={label} role="status">
      <div className="zo-shell-skeleton__nav hidden w-[var(--zo-nav-width-collapsed)] shrink-0 md:block" aria-hidden />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="h-[var(--zo-topbar-height)] shrink-0 border-b border-border bg-surface-1" aria-hidden />
        <div className="flex flex-col gap-4 p-6">
          <Skeleton shape="text" lines={2} width="32%" label={label} />
          <SkeletonTable rows={8} cols={6} />
        </div>
      </div>
    </div>
  );
}
